const dayjs = require('dayjs');

const getDateSequence = (from, duration, weekdays = [1,2,3,4,5]) => {
    const start = dayjs(from);
    const dates = [];

    if (weekdays.includes(start.day())) {
        dates.push(start.valueOf())
    }

    let counter = 0;

    while (dates.length < duration) {
        ++counter;
        const date = start.add(counter, 'days');
        if (weekdays.includes(date.day())) {
            dates.push(date.valueOf());
        }
    } 

    return [...dates];
}

const daysBetween = ({from, until}) => {
    // by default dayjs excludes the start and end date so add 2 so that monday to friday is 5 days etc
    return dayjs(from).diff(dayjs(until), 'day') + 2;
}

const workDaysBetween = ({from, until, weekdays = [1,2,3,4,5]}) => {
    const firstDate = dayjs(from);
    const lastDate = dayjs(until);
    const dates = [];

    if (weekdays.includes(firstDate.day())) {
        dates.push(firstDate.valueOf());
    }

    var nextDate = firstDate.add(1, 'day');

    while (nextDate.valueOf() <= lastDate.valueOf()) {
        if (weekdays.includes(nextDate.day())) {
            dates.push(nextDate.valueOf());
        }
        nextDate = nextDate.add(1, 'day');
    }

    return [...dates];
}

const parseDate = text => {
    // assume yyyy-mm-dd format 
    
    if (text?.seconds) {
        text = new Date(text?.seconds).toISOString();
    }


    return new Date(text.slice(0, 10)).valueOf();
}

const getDate = datetime => {
    return new Date(dayjs(datetime).format("YYYY-MM-DD")).valueOf();
}

const getISODate = datetime => {
    return datetime.toISOString().slice(0,10);
}

export { 
    getDateSequence,
    daysBetween,
    workDaysBetween,
    parseDate,
    getDate,
    getISODate
}